import { Outlet, useNavigate } from 'react-router-dom';
import { useProfile } from '@/lib/providers';
import { AdminRole } from '@/types/custom';
import Loading from '@/components/loading';

export default function AdminLayout() {
  const { profile, loadingProfile } = useProfile();
  const isAdmin = profile?.role === AdminRole;
  const navigate = useNavigate();

  if (loadingProfile) {
    return <Loading />;
  }

  if (!loadingProfile && !isAdmin) {
    navigate('/');
  }

  return (
    <main className="flex-1 overflow-y-auto p-8">
      <Outlet />
    </main>
  );
}
